import { Flex, useColorMode, useColorModeValue } from '@chakra-ui/react';

import SidebarResponsive from '../../components/Sidebar/SidebarResponsive';
import React from 'react';
import { useSignOut } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';
import { FiLogOut } from 'react-icons/fi';
import { HiOutlineLightBulb } from 'react-icons/hi';

export default function ColorMenuNavbarLinks(props) {
  const { secondary, ...rest } = props;
  const { toggleColorMode } = useColorMode();
  const signOut = useSignOut();
  const navigate = useNavigate();

  // Chakra Color Mode
  let textColor = useColorModeValue('#718196', '#f8f8f8');

  const logout = () => {
    signOut();
    navigate('/admin_area/signin');
  };

  return (
    <Flex
      pe={{ sm: '0px', md: '16px' }}
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
    >
      {/* меню */}
      <SidebarResponsive
        logoText={props.logoText}
        secondary={props.secondary}
        {...rest}
      />

      {/* лампочка */}
      <HiOutlineLightBulb
        cursor="pointer"
        onClick={toggleColorMode}
        style={{
          marginLeft: '12px',
          marginRight: '12px',
          width: '20px',
          height: '20px',
          color: textColor,
        }}
      />

      {/* выход */}
      <FiLogOut
        cursor="pointer"
        onClick={logout}
        style={{
          width: '20px',
          height: '20px',
          color: textColor,
        }}
      />
    </Flex>
  );
}
